import React from 'react';
import LogoutNavDesktop from "./NavbarComponents/LogoutNavDesktop";
import {useLocation} from "react-router-dom";
import SwitchCompany from "./NavbarComponents/SwitchCompany";

const NavbarDesktop = () => {
    const route=useLocation()
    const {pathname}=route
    return (
        <>
            {
                pathname === '/adminCompany' ?
                    <LogoutNavDesktop/>
                    :
                    <div className="flex items-center gap-3">
                        <SwitchCompany/>
                        <LogoutNavDesktop/>
                    </div>
            }
        </>
    );
};

export default NavbarDesktop;